import {
  ENTIDADES_ENQUADRAMENTOS_REGRAS_ADD,
  ENTIDADES_ENQUADRAMENTOS_REGRAS_LIST,
  ENTIDADES_ENQUADRAMENTOS_REGRAS_MODIFY,
  ENTIDADES_ENQUADRAMENTOS_REGRAS_REMOVE,
  ENTIDADES_ENQUADRAMENTOS_REGRAS_SYS,
} from "../const/servicesURI";

import { httpRequests } from "investira.sdk";
import requestService from "./requestService";
import utils from "../utils";

export const cancel = {
  list: null,
  sys: null,
};

export const sys = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.sys) {
    cancel.sys.cancel();
  }

  cancel.sys = httpRequests.cancelToken();

  const xProps = {
    ...pProps,
    cancelToken: cancel.sys.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_REGRAS_SYS, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(
        rErr,
        "Error Service Entidades Enquadramentos Regras Sys"
      );
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const list = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pProps,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_REGRAS_LIST, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidades Enquadramentos List");
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    method: "POST",
    ...pProps,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_REGRAS_ADD, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(
        rErr,
        "Error Service Entidades Enquadramentos Regras Add"
      );
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pProps, pResolve, pReject, pFinally) => {
  const xProps = {
    method: "PATCH",
    ...pProps,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_REGRAS_MODIFY, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(
        rErr,
        "Error Service Entidades Enquadramentos Regras Modify"
      );
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
    method: "DELETE",
  };

  return requestService(xProps, `${ENTIDADES_ENQUADRAMENTOS_REGRAS_REMOVE}`, 3)
    .then((rRes) => {
      pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidade Regras Delete");
      pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const entidadesEnquadramentoRegras = {
  list,
  remove,
  add,
  modify,
  sys,
  cancel,
};

export default entidadesEnquadramentoRegras;
